const address = {
    state: {
        checkedAddress: [],//已选的邮箱地址索引数据
        indexListAddress: [],//当前页索引数据
        persTreeFresh: false,
        orgVersion: 0,
        persVersion: 0,
        orgAddress: [],
        persAddress: [],
        currGroupData: null,
        groupOperType: '',
        personOperType: '',
        currAddressType: 'pers',
        treeViewLastClickNodeId: '',
    },
    mutations: {
        SET_CHECKED_ADDRESS: (state, checkedAddress) => {
            state.checkedAddress = checkedAddress;
        },
        SET_INDEX_ADDRESS: (state, indexListAddress) => {
            state.indexListAddress = indexListAddress;
        },
        SET_PERS_FRESH: (state, persTreeFresh) => {
          state.persTreeFresh = persTreeFresh;
        },
        SET_PERS_VERSION: (state, persVersion) => {
            state.persVersion = persVersion;
        },
        SET_ORG_VERSION: (state, orgVersion) => {
            state.orgVersion = orgVersion;
        },
        SET_ORG_ADDRESS: (state, orgAddress) => {
            state.orgAddress = orgAddress;
        },
        SET_PERS_ADDRESS: (state, persAddress) => {
            state.persAddress = persAddress;
        },
        SET_CURRGROUPDATA: (state, currGroupData) => {
            state.currGroupData = currGroupData;
        },
        SET_GROUPOPERTYPE: (state, groupOperType) => {
            state.groupOperType = groupOperType;
        },
        SET_PERSONOPERTYPE: (state, personOperType) => {
            state.personOperType = personOperType;
        },
        SET_CURRADDRESSTYPE: (state, currAddressType) => {
            state.currAddressType = currAddressType;
        },
        SET_TREE_VIEW_LAST_CLICK_NODE_ID:(state, treeViewLastClickNodeId) => {
            state.treeViewLastClickNodeId = treeViewLastClickNodeId;
        },
    }
}

export default address;



// WEBPACK FOOTER //
// ./src/store/modules/address.js